import React from "react";
import Link from "jl-design-system/elements/link/Link";
import cx from "classnames";

import logoB from "../../assets/logos/Brand.svg";
import styles from "./header.scss";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { ENV_VARS } from "../../../config";

const Header = ({ content, userInfo, basketCount, breadcrumbConfig }) => (
  <header className={styles.header}>
    <div className={styles.container}>
      <ul className={styles.skipLinks}>
        <li>
          <Link to="#main" isExternal className={styles.skipTo}>
            Skip to main content
          </Link>
        </li>
        <li>
          <Link to="#footer" isExternal className={styles.skipTo}>
            Skip to footer
          </Link>
        </li>
      </ul>
      <a href={content.browse_url} className={styles.logo}>
        <img src={logoB} alt={content.logo_alt_b} />
      </a>
      <div className={cx(styles["header-link--container"], "flex-1")}>
        <Breadcrumb data-testid="header-continue-shopping-link" className={styles["header-link--continue-shopping"]} text="Our services" {...breadcrumbConfig} />
      </div>
      {!!userInfo && (
        <nav className={styles.nav}>
          <ul>
            <li
              style={{
                transition: "0.3s",
                opacity: userInfo ? 1 : 0,
              }}
            >
              <Link isExternal to={`${ENV_VARS.REACT_APP_BROWSE_HOST}/sign-out`}>
                Sign out
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </div>
  </header>
);

export default Header;
